core.component('core.tagsModalComponent', {
    templateUrl: 'components/tagsModal/tagsModal.html',
    controller: 'core.tagsModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

core.controller('core.tagsModalController', ['$scope', 'coreLanguage', function($scope, $text) {
    const $ctrl = this;
    $scope.$text = $text;

    const formErrosDefault = {
        nome:{},
        cor:{}
    };

    $ctrl.formErrors = formErrosDefault;

    $ctrl.corOptions = [
        {name: 'Azul', class:"text-info"},
        {name: 'Amarelo', class:"text-warning"},
        {name: 'Vermelho', class:"text-danger"},
        {name: 'Preto', class:"text-dark"},
        {name: 'Verde', class:"text-success"}
    ];

    $ctrl.close=()=>{
        $ctrl.config.show = false;
        $ctrl.formErrors = formErrosDefault;
    };

    $ctrl.onBlur = (field) => {

        $ctrl.formErrors[field] = {
            field: !$scope.formTag[field].$valid,
            hint: !$scope.formTag[field].$valid
        };
    };

    $ctrl.validateForm=()=>{

        if($scope.formTag.$valid){
            $ctrl.config.confirm();
        }
        
    };

}]);